'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preFillFieldsFromVisitorContext = exports.preFillFieldsFromQueryParams = exports.updateUser = exports.clearUser = undefined;

var _once = require('hs-lodash/once');

var _once2 = _interopRequireDefault(_once);

var _UserInfoActionTypes = require('../actionTypes/UserInfoActionTypes');

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _actionWithPayload = require('../utils/actionWithPayload');

var _actionWithPayload2 = _interopRequireDefault(_actionWithPayload);

var _getUtk = require('../utils/getUtk');

var _getUtk2 = _interopRequireDefault(_getUtk);

var _serviceWorkerSetup = require('../utils/serviceWorkerSetup');

var serviceWorkerSetup = _interopRequireWildcard(_serviceWorkerSetup);

var _VisitorContextActions = require('./VisitorContextActions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var installPrecachingServiceWorker = (0, _once2.default)(serviceWorkerSetup.install);

var clearUser = exports.clearUser = function clearUser() {
  return (0, _actionWithPayload2.default)(_UserInfoActionTypes.STORE_USERDATA, {
    firstName: null,
    lastName: null,
    companyName: null,
    email: null,
    password: null,
    company: null
  });
};

var updateUser = exports.updateUser = function updateUser(data) {
  /*
  * We want to wait to install the precaching service worker
  * until we think that there is a good chance that the user
  * will complete signup & continue on to setup.
  *
  * Having inputted personal data seems like a fair
  * place to make this assumption for now.
  *
  * Note - the install function is wrapped in _.once()
  */
  installPrecachingServiceWorker();
  return (0, _actionWithPayload2.default)(_UserInfoActionTypes.STORE_USERDATA, data);
};

var preFillFieldsFromQueryParams = exports.preFillFieldsFromQueryParams = function preFillFieldsFromQueryParams() {
  var email = _QueryParamsContainer2.default.get('email');
  var domain = _QueryParamsContainer2.default.get('domain') || _QueryParamsContainer2.default.get('website') || null;
  var companyName = _QueryParamsContainer2.default.get('companyName') || _QueryParamsContainer2.default.get('company') || null;
  var firstName = _QueryParamsContainer2.default.get('firstName') || _QueryParamsContainer2.default.get('firstname') || null;
  var lastName = _QueryParamsContainer2.default.get('lastName') || _QueryParamsContainer2.default.get('lastname') || null;
  return updateUser({ email: email, domain: domain, companyName: companyName, firstName: firstName, lastName: lastName });
};

var preFillFieldsFromVisitorContext = exports.preFillFieldsFromVisitorContext = function preFillFieldsFromVisitorContext() {
  return function (dispatch) {
    dispatch((0, _VisitorContextActions.getPublicVisitorContext)((0, _getUtk2.default)()));
  };
};